import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormControlDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { DocumentService } from 'src/app/feature-module/documents/service/document.service';
import { ControlSettings } from 'src/app/shared/controls/ControlSettings';
import { ProofDocument } from '../../models/ProofDocument';

@Component({
  selector: 'proof-documents-multiselect-ctrl',
  templateUrl: './proof-documents-multiselect.component.html',
  styleUrls: ['./proof-documents-multiselect.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: ProofDocumentsMultiselectComponent,
    multi: true
  }]
})
export class ProofDocumentsMultiselectComponent implements ControlValueAccessor,OnInit  {

  constructor(protected controlContainer: ControlContainer, 
    private documentService: DocumentService) {

  }

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;
  
  proofDocuments$: Observable<ProofDocument[]>;

  @Input() public formControlName: string;
  @Input() caption: string;
 
  @Input() settings:ControlSettings = {};
  defaultSettings:ControlSettings = {fxFill:false};

  @Input() claimIdentifier: string;

  @Output() valueChangeEvent = new EventEmitter<any>();

  ngOnInit(): void {
     Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;

    this.proofDocuments$ = this.documentService.getProofDocuments( this.claimIdentifier);
  }

  onChange(value: any) {
    this.valueChangeEvent.emit(value);
  }

  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }


  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }


  public sizes: Array<string> = ["Small", "Medium", "Large"];
  public selectedSizes: Array<string> = [];

  public onSizeChange(value) {
    this.selectedSizes = value;
  }

}